/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
interface CustomAPI {
  id?: string;
  name: string;
  endpoint: string;
  region: string;
}

interface EndevConfig {
  oid?: string;
  uid?: string;
  ctype?: number;
  curl?: string;
  cid?: string;
  api?: string;
  apiid?: string;
  title?: string;
  mainColor1?: string;
  mainColor2?: string;
  domain?: string;
  adminpoolid?: string;
  adminclientid?: string;
  apiname?: string;
  webinvokeurl?: string;
  admininvokeurl?: string;
  adminapiname?: string;
  adminapiid?: string;
  webapiname?: string;
  webapiid?: string;
  SCHEMA_NAME?: string;
  defaultTenant?: string;
  defaultSTID?: number;
  mt_id?: number;
  secretKey?: string;
  secretKeyAfter?: string;
  OPENAI_API_KEY?: string;
  ENDPOINT?: string;
  aws_project_region?: string;
  aws_cloud_logic_custom?: CustomAPI[];
  aws_cognito_region?: string;
  aws_user_pools_id?: string;
  aws_user_pools_web_client_id?: string;
  aws_org_id?: string;
  main_color_1?: string;
  main_color_2?: string;
  platform_main_theme?: string;
  button_color_web?: string;
  aws_cloudfront_url?: string;
  DOMAIN?: string;
  aws_cloudfront_lurl?: string;
  learningpath?: boolean;
  appVersion?: string;
  auth_url?: string;
  schema?: string;
  aws_cloud_logic_custom_endpoint?: string;
  aws_cloud_logic_custom_name?: string;
  signUp?: boolean;
  profileSet?: string;
  home?: string;
  header?: string;
  ratingFeature?: string;
  course?: string;
  socialLearning?: boolean;
  competency?: boolean;
  activeUsers?: boolean;
  adminfeatures?: any;
  adminlabels?: any;
  admindomain?: string;
  external_api?: string;
  excelearnsso?: boolean;
  sso?: any;
  supersetLink?: string;
  livesession?: any;
  badgesbaseurl?: string;
  sarasEAssessment?: any;
  xapi_credentials?: any;
  typesOfContent?: any;
  webUrl?: any;
  aws_cognito_identity_pool_id?: any;
}

export const Theme = {
  color: {
    primary: "#093055",
    secondary: "#f18121",
    iconColor: "#1C6D9C",
    secondaryLight: "rgba(40, 87, 129, 0.2)",
    text: "#000",
    white: "#fff",
    primaryMain: "#217fb5",
  },
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
};

const nextgen_admin_dev_jeevaraksha: EndevConfig = {
  oid: "JEEVARAKSHA",
  ctype: 0,
  curl: "d3d5cobna2tkyx.cloudfront.net",
  apiid: "sui49u4i14",
  title: "JEEVARAKSHA",
  mainColor1: "#304885",
  main_color_1: "#6E2B69",
  main_color_2: "#6E2B69",
  mainColor2: "#F5B001",
  domain: "d3d5cobna2tkyx.cloudfront.net",
  webinvokeurl: "https://sui49u4i14.execute-api.ap-south-1.amazonaws.com/dev",
  webapiid: "sui49u4i14",
  SCHEMA_NAME: "jeevaraksha",
  defaultTenant: "Default Team",
  defaultSTID: 1,
  mt_id: 1,
  aws_project_region: "ap-south-1", // AWS Region
  aws_cloud_logic_custom: [
    {
      id: "sui49u4i14",
      name: "dev-jeevaraksha-admin",
      endpoint: "https://sui49u4i14.execute-api.ap-south-1.amazonaws.com/dev",
      region: "ap-south-1",
    },
    // Add more custom APIs as needed
  ],
  aws_cloud_logic_custom_name: "dev-jeevaraksha-admin",
  aws_org_id: "JEEVARAKSHA",
  aws_cognito_identity_pool_id: "",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_OXyNF1Lyb",
  aws_user_pools_web_client_id: "mb41elqvdvktvv4becll526dc",
  DOMAIN: "www.dev-jeevaraksha-admin.enabled.live",
  platform_main_theme: "linear-gradient(#275780, #275780)",
};

export default nextgen_admin_dev_jeevaraksha;
